import { render, staticRenderFns } from "./manualStudent.vue?vue&type=template&id=68e78400&"
import script from "./manualStudent.vue?vue&type=script&lang=js&"
export * from "./manualStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports